export default function Interest(){
    return(
        <div className="interest">
            <h3>Interests</h3>
            <p>
            Ailurophile.Love Baking and painting. Fiction fanatic.
            </p>
        </div>
    )
}